"use client";

import React, { useEffect, useState } from "react";
import { MapPin, Clock, Building2, ArrowRight } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const locations = [{
  id: "hq",
  city: "London",
  country: "United Kingdom",
  address: "Unit 12, Industrial Way, London SE1 7PB",
  top: "38%",
  left: "22%",
  timezone: "Europe/London",
  isHQ: true
}, {
  id: "eu",
  city: "Manchester",
  country: "United Kingdom",
  address: "Grid Park, Trafford Park, M17 1QS",
  top: "28%",
  left: "48%",
  timezone: "Europe/London",
  isHQ: false
}, {
  id: "asia",
  city: "Birmingham",
  country: "United Kingdom",
  address: "Power House, Digbeth, B5 6DY",
  top: "35%",
  left: "82%",
  timezone: "Europe/London",
  isHQ: false
}, {
  id: "oceania",
  city: "Glasgow",
  country: "United Kingdom",
  address: "Clyde Infrastructure Hub, G3 8AZ",
  top: "75%",
  left: "88%",
  timezone: "Europe/London",
  isHQ: false
}];
export default function OurGlobalKitchen() {
  const [mounted, setMounted] = useState(false);
  const [currentTime, setCurrentTime] = useState<Date>(new Date());
  useEffect(() => {
    setMounted(true);
    const timer = setInterval(() => setCurrentTime(new Date()), 60000);
    return () => clearInterval(timer);
  }, []);
  const getLocalTime = (timeZone: string) => {
    if (!mounted) return "--:--";
    try {
      return new Intl.DateTimeFormat("en-US", {
        timeStyle: "short",
        timeZone
      }).format(currentTime);
    } catch (e) {
      return "--:--";
    }
  };
  return;
}